/**
 * @desc 外部系统调用供应商列表
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierInfo.transferPage.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierInfo/transferPage`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
